import { DeliveryStatus } from 'api/models/Deliveries';
import { TableTypes } from 'pages/ActionItems/types';
import { addBusinessDays, subtractBusinessDays } from 'utils/helpers/DateTimeFormat.helpers';

const highlightRed = (
  surgeryDate: string | Date,
  express: boolean,
  status: DeliveryStatus,
  selectedRateName = '',
  tableType: TableTypes = TableTypes.DEFAULT,
): boolean => {
  const surgeryDateObj = new Date(surgeryDate);
  const surgeryDateFormatted = surgeryDateObj.toISOString().split('T')[0];
  const surgeryDateNum = surgeryDateObj.getTime();
  const now = new Date();
  const oneBusinessDayFromNow = addBusinessDays(now, 1).getTime();
  const threeBusinessDaysAgo = subtractBusinessDays(now, 3).getTime();
  const nowFormatted = now.toISOString().split('T')[0];

  // the smartways service rate Patient On Table or Next Flight is priority
  const isUrgentService = selectedRateName.match(/\bPOT\b/) || selectedRateName.match(/\bNext\s*Flight\b/i);
  if (isUrgentService && (status == 'OUTBOUND' || status == 'DELIVERED' || status == 'RECEIVED')) {
    return true;
  }

  if (tableType === TableTypes.DEFAULT) {
    return (
      (status == 'OUTBOUND' && surgeryDateNum < oneBusinessDayFromNow) ||
      ((status == 'RECEIVED' || status == 'DELIVERED') && surgeryDateFormatted === nowFormatted) ||
      (status == 'CHECKED_IN' && surgeryDateNum < threeBusinessDaysAgo) ||
      express
    );
  } else if (tableType === TableTypes.RECEIVE_OVERDUE) {
    return surgeryDateNum < oneBusinessDayFromNow;
  } else if (tableType === TableTypes.CHECK_IN_OVERDUE) {
    return surgeryDateNum < oneBusinessDayFromNow;
  } else if (tableType === TableTypes.CRITICAL_ITEMS) {
    return surgeryDateNum < oneBusinessDayFromNow;
  } else if (tableType === TableTypes.CHECK_OUT_OVERDUE) {
    return surgeryDateNum < threeBusinessDaysAgo;
  } else {
    return false;
  }
};

export default highlightRed;
